import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HomeOutlined,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  PollOutlined,
  DatasetOutlined,
  DescriptionOutlined,
  GroupOutlined,
  AccountCircleOutlined,
  LogoutOutlined,
  BackupTableOutlined
} from "@mui/icons-material";
import './Sidebar.css';
import logo from "../assets/main-logo.png";
import mlogo from "../assets/mobile-logo.png";


const Sidebar = () => {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    // Optional: Force layout recalculation
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 300); // match your CSS transition time
  };

  const navItems = [
    { label: "Home", icon: <HomeOutlined />, path: "/portal/home" },
    { label: "Projects", icon: <BackupTableOutlined/>, path: "/portal/project" },
    { label: "Dashboards", icon: <PollOutlined />, path: "/portal/dashboard" },
    { label: "Data", icon: <DatasetOutlined />, path: "/portal/data" },
    { label: "Forms", icon: <DescriptionOutlined />, path: "/portal/forms" },
    { label: "Users", icon: <GroupOutlined />, path: "/portal/users" },
    { label: "Profile", icon: <AccountCircleOutlined />, path: "/portal/profile" },
  ];

  return (
    <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
      <Link to="/portal/home">
          <img src={logo} alt="Logo" className="login-logo desktop-logo" />
        </Link>
        <Link to="/portal/home">
  <img src={mlogo} alt="Mobile Logo" className="login-logo mobile-logo" />
  </Link>
  
  <button className="toggle-btn" onClick={toggleCollapse}>
    {isCollapsed ? <KeyboardDoubleArrowRight /> : <KeyboardDoubleArrowLeft />}
  </button>
</div>


      <nav className="nav-container">
        <ul className="nav-top">
          {navItems.map((item) => (
            <li key={item.label} className={location.pathname === item.path ? "active" : ""}>
              <Link to={item.path}>
                {item.icon}
                {!isCollapsed && <span>{item.label}</span>}
              </Link>
            </li>
          ))}
        </ul>

        <ul className="nav-bottom">
          <li className={location.pathname === "/portal/logout" ? "active" : ""}>
            <Link to="/portal/logout">
              <LogoutOutlined />
              {!isCollapsed && <span>Logout</span>}
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
